// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "doSearch",
                "observers": [
                    "props.accsessionid",
                    "props.provider",
                    "props.catalogspaceid"
                ]
            }
        ]
    },
    "data": {
        "searchBox": {
            "displayName": "{{i18n.searchBoxdisplayName}}",
            "type": "STRING",
            "dbValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchBoxplaceholder}}"
        },
        "desTotalCount": 0
    },
    "actions": {
        "doSearch": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiated",
                        "eventData": {
                            "eventName": "searchInitiated",
                            "searchInput": [
                                "{{props.provider}}",
                                "{{data.searchBox.dbValue}}",
                                "{{data.desTotalCount}}"
                            ]
                        },
                        "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length > 0"
                    }
                ]
            }
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "searchInitiatedSuccess": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiatedSuccess",
                        "eventData": {
                            "eventName": "searchInitiatedSuccess",
                            "eventData": "{{parameters.eventData}}"
                        }
                    }
                ]
            }
        },
        "searchInitiatedSuccessForCrumb": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiatedSuccessForCrumb",
                        "eventData": {
                            "eventName": "searchInitiatedSuccessForCrumb",
                            "eventData": "{{parameters.eventData}}"
                        }
                    }
                ]
            }
        },
        "performBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "searchInitiatedSuccessForCrumb",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "searchInitiatedSuccess",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "clearSeachBox": {
            "actionType": "JSFunction",
            "method": "clearSeachBox",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/desSearchService"
        },
        "actionOnClearIcon": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "des-catalog-search-box.cleared"
            },
            "deps": "js/desCatalogEventBus"
        },
        "actionOnClearIconClick": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "searchBoxClearEvent"
                },
                {
                    "action": "actionOnClearIcon"
                }
            ]
        },
        "searchBoxClearEvent": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchBoxClearEvent",
                        "eventData": {
                            "eventName": "searchBoxClearEvent"
                        }
                    }
                ]
            }
        }
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "contentpath": {
            "type": "string"
        }
    },
    "onEvent": [
        {
            "eventId": "searchInitiated",
            "action": "performBatchAction",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.searchInput}}"
            }
        }
    ],
    "i18n": {
        "searchBoxplaceholder": [
            "searchMessages"
        ],
        "searchBoxdisplayName": [
            "searchMessages"
        ]
    },
    "_viewModelId": "DesCatalogSearchBox",
    "_uniqueViewModelId": "DesCatalogSearchBox",
    "ctx": {}
};

    /*
    <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearch" reset-action="actionOnClearIconClick">
</aw-search-box>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.doSearch} resetAction={actions.actionOnClearIconClick}>
    </AwSearchBox>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;